import Location from "../../hooks/Location.js"
import PageHeader from "../../components/layout/PageHeader.jsx";
import { client } from "../../hooks/Client.js"
import sanitizeHtml from "../../utils/sanitizeHtml"
import { useHistory } from "react-router-dom";
import { useFirestoreGeneral } from "../../firebase/useFirestore.js";
import ResearchMeta from "../../components/Research/ResearchMeta.jsx";
import FieldMeta from "../../components/Questionnaire/FieldMeta.jsx";
import { useEffect, useState } from "react";
import CombinedOutputData from '../../components/graphData/CombinedOutputData';

const EditAnalysis = () => {
    // State
    const [title, setTitle] = useState('');

   // Hooks
   const insightId = Location()[3]
   const history = useHistory()

   // Firestore
   const analysis = useFirestoreGeneral('Analysis', 'ID', insightId ? insightId : '')

    // Effect to set the title when analysis is loaded
    useEffect(() => {
        if (analysis && analysis.length > 0) {
            setTitle(analysis[0].Title);
        }
    }, [analysis]);

   // Switch to find the right insight type
    const insightType = (type) => {

     switch(type) {
            case 'cross-research-question-comparison':
                return 'Vergelijking onderzoeken'
            case 'sentiment-analyse-researches':
                return 'AI analyse onderzoeken'
            case 'complete-progress-analysis':
                return 'AI voortgangsanalyse'
            case 'cross-research-question-comparison':
                return 'Vergelijking onderzoeken één vraag'
            case 'sentiment-analyse-open-question':
                return 'AI analyse open vraag'
            case 'persona-complete-analysis':
                return 'Persona analyse'
            case 'combined-research-analysis':
                return 'Gecombineerde onderzoeksanalyse'
            case 'compare-outputs-analysis':
                return 'Vergelijking outputs'
            default:
                return 'Onbekend'
        }
  }

  const InsightContentType = ({item}) => {

    switch(item.Type) {
        case 'sentiment-analyse-researches':
            return <div>
                <div className="table-container dashboard-container">
                    <h2>Onderzoek</h2>
                    {item.Research && item.Research.map(research => (
                        <p>{<ResearchMeta item={research}/>}</p>
                    ))}
                </div>
                <div className="table-container dashboard-container">
                    <h2>Content</h2>
                    <p dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.Content) }}></p>
                </div>
              
            </div>
        case 'complete-progress-analysis':
            return <div>
                <div className="table-container dashboard-container">
                    <p><b>Researches</b></p>
                    <p>Researches</p>
                </div>
               <div className="table-container dashboard-container">
                <p><b>Questions</b></p>
                <p>Questions</p>
               </div>
              
            </div>
        case 'cross-research-question-comparison':
            return <div>
                <div className="table-container dashboard-container">
                    <h2>Onderzoek</h2>
                    {item.Research && item.Research.map(research => (
                        <p>{<ResearchMeta item={research}/>}</p>
                    ))}
                </div>
                <div className="table-container dashboard-container">
                <h2>Vergeleken vraag</h2>
                <p>{<FieldMeta item={item.CrossResearchResults[0]?.fieldId}/>}</p>
               </div>
               <div className="table-container dashboard-container">
                <h2>Gemiddelde score</h2>
                <p>{item.AverageInput}</p>
               </div>
               
            </div>
        case 'sentiment-analyse-open-question':
            return <div>
                <div className="table-container dashboard-container">
                    <h2>Onderzoek</h2>
                    <p>{<ResearchMeta item={item.Research[0]}/>}</p>
                </div>
                <div className="table-container dashboard-container">
                    <h2>Open vraag</h2>
                    <p>{<FieldMeta item={item.QuestionFieldID}/>}</p>
                </div>
                <div className="table-container dashboard-container">
                    <h2>Content</h2>
                    <p dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.Content) }}></p>
                </div>
            </div>
        case 'combined-research-analysis':
            return (
            <div>
                <div className="table-container dashboard-container">
                    <h2>Gecombineerde onderzoeken</h2>
                    {item.Content && item.Content.map(research => (
                        <p>{<ResearchMeta item={research}/>}</p>
                    ))}
                </div>
            </div>
            )
        case 'compare-outputs-analysis':
            return (
                <div>
                    <div className="table-container dashboard-container">
                        <h2>Vergelijking outputs</h2>
                        <CombinedOutputData outputIds={item.Content} startDate={item.StartDate} endDate={item.EndDate} graphType={'bar'} />
                    </div>
                </div>
            )
        default:
            return 'Onbekend'
    }
}


  return (
    <div className="main">
      <div className="main-container">
          <PageHeader 
              heading={'Analyse aanpassen'}
              subHeading={title}
              description={`Pas de instellingen van de analyse aan.`}
              AI={false}
          />
          <div className="table-container">
            {analysis && analysis.map(item => (
                <div key={item.ID} className="analysis-item-container">
                    <h1>{item.Title}</h1>
                    <div className="table-container dashboard-container">
                        <h2>Type</h2>
                        <p>{insightType(item.Type)}</p>
                    </div>
                    <InsightContentType item={item}/>
                </div>
            ))}
          </div>
      </div>
    </div>
  )
}

export default EditAnalysis